import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CAMPAIGN } from "../Components/Home/AdLanding";
import { fetchTevoListingPrice } from "../Components/Home/MarketplaceNewUI/marketplaceHotEventPrices";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toast from "react-hot-toast";
import {
  Calendar,
  MapPin,
  Clock,
  Minus,
  Plus,
  // Share2,
  // Heart,
  X,
  // QrCode,
  Shield,
  Zap,
  Users,
  // Copy,
  // Facebook,
  // Twitter,
} from "lucide-react";
import {
  GetCommunityEventById,
  GetEventsDeatils,
  GetSingleEventById,
} from "../redux/actions/Events";
import { isMongoEventId } from "../Components/Home/chatEventLinks";
import { ApiMediaURL } from "../setting/GlobleVariable";
import { MarketplaceEventBadge } from "../Components/Home/MarketplaceNewUI/MarketplaceEventBadge";
import MarketplaceNewUIFooter from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIFooter";
import Loadingcom from "../Components/Loading/Loading";
import { copyToClipboard } from "../utils/clipboard";
// import { faqItems } from "../data/marketplaceMockEvents";
import {
  transformUserCreatedTickets,
  normalizeTicketRows,
  mapEventForDisplay,
  computeSoldPercent,
  buildCheckoutPayload,
  quantityAllowed,
} from "../Components/PagesCompoents/GroupDeatils/eventGroupDetailHelpers";
import EventSeatMapPanel from "../Components/PagesCompoents/GroupDeatils/EventSeatMapPanel";
import RsvpCard from "../Components/PagesCompoents/GroupDeatils/RsvpCard";
import StayNearVenueCard from "../Components/PagesCompoents/GroupDeatils/StayNearVenueCard";
import {
  highlightTicketOnMap,
  clearMapHighlight,
  findTicketRowIdForSeaticsItem,
} from "../Components/PagesCompoents/GroupDeatils/eventSeatMapUtils";

function EventGroupDetailLive() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [ticketData, setTicketData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [mapReady, setMapReady] = useState(false);
  const [filtertheEvent, setFiltertheEvent] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [selectedTier, setSelectedTier] = useState(null);
  // const [openFaq, setOpenFaq] = useState(null);
  // const [saved, setSaved] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [mapFilterIds, setMapFilterIds] = useState(null);
  const [hoveredTicketId, setHoveredTicketId] = useState(null);
  const [filterQty, setFilterQty] = useState("");
  // Parking passes are listed apart from seats (same as the app)
  const [showParking, setShowParking] = useState(false);
  const shareRef = useRef(null);

  const receivedData = location.state?.data;
  const heroImage = location.state?.image;
  const receivedUserCreated = Boolean(receivedData?.[0]?._isUserCreated);
  const [fetchedUserCreated, setFetchedUserCreated] = useState(false);
  const isUserCreatedEvent =
    receivedUserCreated ||
    fetchedUserCreated ||
    Boolean(filtertheEvent?.[0]?._isUserCreated);
  const AllEvents = useSelector((state) => state.events.AllEvents);
  const currentUser = useSelector((state) => state.user?.user);

  // Free organizer events (every ticket type $0) get an RSVP form instead of checkout.
  const organizerTickets = filtertheEvent?.[0]?.userTickets || [];
  const isRsvpEvent =
    isUserCreatedEvent &&
    organizerTickets.length > 0 &&
    organizerTickets.every((t) => !(parseFloat(t.price) > 0));
  const rsvpTicket = isRsvpEvent ? organizerTickets[0] : null;
  const rsvpEventId = filtertheEvent?.[0]?._id || (isMongoEventId(id) ? id : null);
  const rsvpCap = parseInt(rsvpTicket?.quantity, 10) || 0;
  const rsvpRemaining =
    rsvpCap > 0 && rsvpTicket?.remaining !== undefined ? Math.max(0, Number(rsvpTicket.remaining)) : null;

  // JAY-Z campaign shows: show "from $X" and the promo code in the header
  // straight away (ad visitors land here), from the small cached price lookup.
  const campaignShow = CAMPAIGN.shows.find((s) => s.eventId === String(id));
  const [quickFromPrice, setQuickFromPrice] = useState(0);
  useEffect(() => {
    let off = false;
    setQuickFromPrice(0);
    if (campaignShow) fetchTevoListingPrice(id).then((p) => !off && setQuickFromPrice(p));
    return () => {
      off = true;
    };
  }, [id, campaignShow]);

  useEffect(() => {
    setMapFilterIds(null);
    setQuantities({});
    setSelectedTier(null);
    setHoveredTicketId(null);
    setFilterQty("");
    setShowParking(false);
    setMapReady(false);
    setFetchedUserCreated(false);
    setFiltertheEvent([]);
    setTicketData([]);
  }, [id]);

  useEffect(() => {
    let cancelled = false;

    const loadPageData = async () => {
      setPageLoading(true);

      if (receivedUserCreated && receivedData?.length) {
        const eventData = receivedData[0];
        if (!cancelled) {
          setFiltertheEvent(receivedData);
          setTicketData(transformUserCreatedTickets(eventData));
          setMapReady(true);
          setPageLoading(false);
        }
        return;
      }

      if (isMongoEventId(id)) {
        const eventData = await dispatch(GetCommunityEventById(id));
        if (cancelled) return;

        if (eventData) {
          setFiltertheEvent([eventData]);
          setTicketData(transformUserCreatedTickets(eventData));
          setFetchedUserCreated(true);
          setMapReady(true);
        }
        setPageLoading(false);
        return;
      }

      setMapReady(false);
      try {
        // Show the event header as soon as its details arrive; the full
        // listings (thousands of rows for a stadium show) can fill in after.
        const eventPromise = (id ? dispatch(GetSingleEventById(id)) : Promise.resolve(null)).then(
          (eventResult) => {
            if (!cancelled && eventResult) setFiltertheEvent([eventResult]);
            return eventResult;
          }
        );
        const [ticketResult] = await Promise.all([
          dispatch(GetEventsDeatils(parseInt(id, 10))),
          eventPromise,
        ]);

        if (cancelled) return;

        if (ticketResult?.success) {
          setTicketData(ticketResult.data || []);
        }
      } finally {
        if (!cancelled) {
          setPageLoading(false);
        }
      }
    };

    loadPageData();

    return () => {
      cancelled = true;
    };
  }, [id, dispatch, receivedUserCreated, receivedData]);

  const handleMapReady = useCallback(() => {
    setMapReady(true);
  }, []);

  useEffect(() => {
    if (pageLoading || isUserCreatedEvent) return;
    if (!ticketData?.length) {
      setMapReady(true);
    }
  }, [pageLoading, isUserCreatedEvent, ticketData]);

  const rawEvent = filtertheEvent?.[0];
  const resolvedHeroImage = useMemo(() => {
    if (heroImage) return heroImage;
    const img = rawEvent?.image;
    if (!img) return null;
    if (typeof img === "string" && img.startsWith("http")) return img;
    return `${ApiMediaURL}/${img}`;
  }, [heroImage, rawEvent?.image]);
  const event = useMemo(
    () => mapEventForDisplay(rawEvent, resolvedHeroImage, isUserCreatedEvent),
    [rawEvent, resolvedHeroImage, isUserCreatedEvent]
  );

  const ticketRows = useMemo(
    () => normalizeTicketRows(ticketData, isUserCreatedEvent),
    [ticketData, isUserCreatedEvent]
  );

  const seatRows = useMemo(
    () => ticketRows.filter((r) => r.raw?.type !== "parking"),
    [ticketRows]
  );
  const parkingRows = useMemo(
    () => ticketRows.filter((r) => r.raw?.type === "parking"),
    [ticketRows]
  );
  const listingParking = showParking && parkingRows.length > 0;

  const displayTicketRows = useMemo(() => {
    if (listingParking) return parkingRows;
    if (!mapFilterIds?.size) return seatRows;
    return seatRows.filter((r) => mapFilterIds.has(r.id));
  }, [listingParking, parkingRows, seatRows, mapFilterIds]);

  const splitList = useMemo(() => {
    const all = (listingParking ? parkingRows : seatRows).flatMap((r) => r.splits || []);
    return [...new Set(all)].filter((n) => n > 0).sort((a, b) => a - b);
  }, [listingParking, parkingRows, seatRows]);

  const filteredTicketRows = useMemo(() => {
    if (!filterQty) return displayTicketRows;
    const q = parseInt(filterQty, 10);
    if (!q) return displayTicketRows;
    return displayTicketRows.filter((row) => {
      if (isUserCreatedEvent) return row.available >= q;
      return row.splits?.includes(q);
    });
  }, [displayTicketRows, filterQty, isUserCreatedEvent]);

  const handleMapTicketsChange = (mapTickets) => {
    if (!mapTickets?.length) {
      setMapFilterIds(null);
      return;
    }
    setShowParking(false);
    const ids = new Set(
      mapTickets
        .map((t) => findTicketRowIdForSeaticsItem(t, ticketRows))
        .filter(Boolean)
    );
    setMapFilterIds(ids.size ? ids : null);

    if (mapTickets.length === 1) {
      const rowId = findTicketRowIdForSeaticsItem(mapTickets[0], ticketRows);
      if (rowId) {
        const row = ticketRows.find((r) => r.id === rowId);
        const qty = row?.splits?.[0] || 1;
        setSelectedTier(rowId);
        setQuantities({ [rowId]: Math.min(qty, row.maxQty, row.available) });
      }
    }
  };

  const handleCommunityTicketSelect = (ticket) => {
    const rowId = String(ticket?.id ?? ticket?.tgID ?? "");
    if (!rowId) return;
    setSelectedTier(rowId);
    setQuantities({ [rowId]: 1 });
  };

  const clearMapFilter = () => {
    setMapFilterIds(null);
    clearMapHighlight();
  };

  const soldPercent = useMemo(
    () => computeSoldPercent(rawEvent, ticketRows),
    [rawEvent, ticketRows]
  );

  const sectionLoading =
    pageLoading || (!isUserCreatedEvent && !mapReady);
  // The hero only needs the event itself, not the listings
  const heroLoading = !rawEvent && pageLoading;

  const getShareUrl = () => {
    const eventId = rawEvent?.id ?? rawEvent?._id ?? id;
    const nameSlug = encodeURIComponent(
      (rawEvent?.name || event?.title || "event").replace(/\s+/g, "-")
    );
    return `${window.location.origin}/tickets/group.details/${eventId}/${nameSlug}`;
  };

  useEffect(() => {
    if (!shareOpen) return undefined;
    const handleClickOutside = (e) => {
      if (shareRef.current && !shareRef.current.contains(e.target)) {
        setShareOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [shareOpen]);

  const handleCopyLink = async () => {
    const success = await copyToClipboard(getShareUrl());
    if (success) {
      toast.success("Link copied to clipboard");
      setShareOpen(false);
    } else {
      toast.error("Could not copy link");
    }
  };

  const openFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getShareUrl())}`,
      "_blank",
      "noopener,noreferrer,width=600,height=400"
    );
    setShareOpen(false);
  };

  const openTwitterShare = () => {
    const text = event?.title || rawEvent?.name || "Check out this event";
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(getShareUrl())}&text=${encodeURIComponent(text)}`,
      "_blank",
      "noopener,noreferrer,width=600,height=400"
    );
    setShareOpen(false);
  };

  const handleFilterQtyChange = (e) => {
    setFilterQty(e.target.value);
    setQuantities({});
    setSelectedTier(null);
  };

  const handleTicketListSelect = (ticket) => {
    const qty = filterQty ? parseInt(filterQty, 10) : 1;
    if (!quantityAllowed(qty, ticket, isUserCreatedEvent)) {
      toast.error(
        filterQty
          ? `Quantity ${filterQty} is not available for this listing`
          : "That quantity is not available for this listing"
      );
      return;
    }
    setSelectedTier(ticket.id);
    setQuantities({ [ticket.id]: qty });
  };

  const handleQuantityChange = (ticketId, change) => {
    const row = ticketRows.find((t) => t.id === ticketId);
    if (!row) return;
    setQuantities((prev) => {
      const next = Math.max(
        0,
        Math.min(row.maxQty, (prev[ticketId] || 0) + change)
      );
      if (next > 0) return { [ticketId]: next };
      return { [ticketId]: 0 };
    });
    setSelectedTier(ticketId);
  };

  const totalQuantity = Object.values(quantities).reduce(
    (sum, qty) => sum + qty,
    0
  );
  const subtotal = ticketRows.reduce(
    (sum, t) => sum + (quantities[t.id] || 0) * t.price,
    0
  );
  const serviceFee = isUserCreatedEvent ? 0 : subtotal * 0.08;
  const facilityFee = isUserCreatedEvent ? 0 : totalQuantity * 3.5;
  const totalPrice = subtotal + serviceFee + facilityFee;

  const similar = useMemo(() => {
    if (!AllEvents?.length || !rawEvent) return [];
    const currentId = String(rawEvent.id ?? rawEvent._id ?? id);
    return AllEvents.filter((e) => {
      const eid = String(e.id ?? e._id);
      return eid !== currentId && e.name;
    })
      .slice(0, 3)
      .map((e) => ({
        item: e,
        id: e.id ?? e._id,
        title: e.name,
        date: e.occurs_at_local || e.occurs_at
          ? moment(e.occurs_at_local || e.occurs_at).format("ddd, MMM D")
          : "",
        price:
          e.listingPrice ??
          e.priceFrom ??
          (e.available_count != null ? "—" : "—"),
      }));
  }, [AllEvents, rawEvent, id]);

  const navigateToSimilar = (item) => {
    const navId = item._isUserCreated ? item._id || item.id : item.id;
    navigate(`/tickets/group.details/${navId}`, {
      state: { data: [item] },
    });
  };

  const handleCheckout = () => {
    const tierId = Object.keys(quantities).find((k) => quantities[k] > 0);
    if (!tierId || !filtertheEvent?.length) {
      toast.error("Select at least one ticket");
      return;
    }
    const row = ticketRows.find((t) => t.id === tierId);
    const qty = quantities[tierId];
    if (!row || !quantityAllowed(qty, row, isUserCreatedEvent)) {
      toast.error("That quantity is not available for this ticket type");
      return;
    }
    const sendorderdata = buildCheckoutPayload(row.raw, qty);
    navigate("/checkout", {
      state: {
        filterevent: filtertheEvent,
        data: sendorderdata,
        id,
        image: heroImage || event?.image,
      },
    });
  };

  if (!pageLoading && !event) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-white text-2xl font-black mb-4">Event Not Found</h2>
          <Link to="/tickets" className="text-red-500 hover:underline">
            Browse All Events
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0F172A]">
      <div className="relative h-[350px] sm:h-[450px] overflow-hidden">
        {heroLoading ? (
          <div className="w-full h-full bg-[#111827] flex items-center justify-center">
            <Loadingcom />
          </div>
        ) : (
          <img
            src={event?.image}
            alt={event?.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.src =
                "https://images.unsplash.com/photo-1449748040579-354c191a7934?w=1200&q=80";
            }}
          />
        )}
        {/* Side vignette + bottom fade for readable hero text */}
        <div
          className="absolute inset-0 pointer-events-none bg-gradient-to-r from-[#0B1120]/95 via-[#0B1120]/35 to-[#0B1120]/95"
          aria-hidden
        />
        <div
          className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#0F172A] via-[#0F172A]/80 to-[#0B1120]/20"
          aria-hidden
        />
        <div
          className="absolute inset-0 pointer-events-none bg-black/25"
          aria-hidden
        />
        {!heroLoading && (
        <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 z-10">
          <div className="max-w-[1400px] mx-auto">
            <div className="flex items-center gap-2 mb-3">
              {event?.badge && (
                <MarketplaceEventBadge variant="trending">
                  {event.badge}
                </MarketplaceEventBadge>
              )}
              {soldPercent > 90 && (
                <MarketplaceEventBadge variant="soldout">
                  Almost Sold Out
                </MarketplaceEventBadge>
              )}
              {soldPercent > 70 && soldPercent <= 90 && (
                <MarketplaceEventBadge variant="soldout">
                  Selling Fast
                </MarketplaceEventBadge>
              )}
            </div>
            <h1 className="text-3xl sm:text-5xl font-black uppercase tracking-tight text-white mb-3 drop-shadow-[0_2px_16px_rgba(0,0,0,0.85)]">
              {event?.title}
            </h1>
            <div className="flex flex-wrap items-center gap-4 text-sm text-white/85 drop-shadow-[0_1px_8px_rgba(0,0,0,0.7)]">
              <span className="flex items-center gap-1.5">
                <Calendar className="w-4 h-4 text-red-500" /> {event?.date}
              </span>
              {event?.time && (
                <span className="flex items-center gap-1.5">
                  <Clock className="w-4 h-4 text-red-500" /> {event.time}
                </span>
              )}
              <span className="flex items-center gap-1.5">
                <MapPin className="w-4 h-4 text-red-500" />{" "}
                {event?.locationLine || event?.venue}
              </span>
            </div>
            {campaignShow && (
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {quickFromPrice > 0 && (
                  <span className="px-3 py-1.5 rounded-full bg-[#E52324] text-white text-sm font-black">
                    From ${quickFromPrice}
                  </span>
                )}
                <span className="px-3 py-1.5 rounded-full border border-dashed border-[#F5C542]/70 bg-black/40 text-[#F5C542] text-xs font-bold uppercase tracking-wide">
                  Code {CAMPAIGN.promo} · {CAMPAIGN.promoDiscount}
                </span>
              </div>
            )}
          </div>
        </div>
        )}
      </div>

      <div
        className={`max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8 ${
          totalQuantity > 0 ? "pb-28" : ""
        }`}
      >
        <div className="space-y-8">
            {/* <div className="flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => setSaved(!saved)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border text-sm transition-all ${
                  saved
                    ? "bg-red-600/10 border-red-600/30 text-red-500"
                    : "border-[#1F2937] text-white/60 hover:bg-white/5"
                }`}
              >
                <Heart className={`w-4 h-4 ${saved ? "fill-current" : ""}`} />{" "}
                {saved ? "Saved" : "Save"}
              </button>
              <div className="relative" ref={shareRef}>
                <button
                  type="button"
                  onClick={() => setShareOpen((open) => !open)}
                  className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border text-sm transition-all ${
                    shareOpen
                      ? "border-red-600/40 bg-white/5 text-white"
                      : "border-[#1F2937] text-white/60 hover:bg-white/5"
                  }`}
                  aria-expanded={shareOpen}
                  aria-haspopup="true"
                >
                  <Share2 className="w-4 h-4" /> Share
                </button>
                {shareOpen && (
                  <div className="absolute top-full left-0 mt-2 w-52 bg-[#111827] border border-[#1F2937] rounded-xl shadow-xl p-2 z-30">
                    <button
                      type="button"
                      onClick={handleCopyLink}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/60 hover:bg-white/5 hover:text-white transition-colors"
                    >
                      <Copy className="w-4 h-4 shrink-0" />
                      Copy Link
                    </button>
                    <button
                      type="button"
                      onClick={openFacebookShare}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/60 hover:bg-white/5 hover:text-white transition-colors"
                    >
                      <Facebook className="w-4 h-4 shrink-0" />
                      Facebook
                    </button>
                    <button
                      type="button"
                      onClick={openTwitterShare}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white/60 hover:bg-white/5 hover:text-white transition-colors"
                    >
                      <Twitter className="w-4 h-4 shrink-0" />
                      Twitter
                    </button>
                  </div>
                )}
              </div>
            </div> */}

            <div className="bg-[#111827] rounded-2xl border border-[#1F2937] p-6">
              <h2 className="text-xl font-black uppercase tracking-tight text-white mb-4">
                About This Event
              </h2>
              <p className="text-white/60 text-sm leading-relaxed">
                {event?.description}
              </p>
            </div>

            <StayNearVenueCard rawEvent={rawEvent} />

            {/* Lineup — hidden for now
            {event?.lineup?.length > 0 && (
              <div className="bg-[#111827] rounded-2xl border border-[#1F2937] p-6">
                <h2 className="text-xl font-black uppercase tracking-tight text-white mb-4">
                  Lineup
                </h2>
                <div className="space-y-3">
                  {event.lineup.map((artist, i) => (
                    <div
                      key={`${artist}-${i}`}
                      className="flex items-center gap-4 p-3 rounded-xl bg-[#0F172A] border border-[#1F2937]"
                    >
                      <div
                        className={`w-10 h-10 rounded-xl flex items-center justify-center font-black text-sm text-white ${
                          i === 0 ? "bg-red-600" : "bg-[#1F2937]"
                        }`}
                      >
                        {i === 0 ? (
                          <Star className="w-5 h-5" />
                        ) : (
                          i + 1
                        )}
                      </div>
                      <div>
                        <div className="text-white font-black text-sm uppercase tracking-tight">
                          {artist}
                        </div>
                        {i === 0 && (
                          <div className="text-red-500 text-[10px] font-black uppercase tracking-wider">
                            Headliner
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            */}

            {/* Organizer — hidden for now
            <div className="bg-[#111827] rounded-2xl border border-[#1F2937] p-6">
              <h2 className="text-xl font-black uppercase tracking-tight text-white mb-4">
                Organizer
              </h2>
              <div className="flex items-center gap-4 flex-wrap">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-red-600 to-red-700 flex items-center justify-center text-white font-black">
                  {event?.organizer?.avatar}
                </div>
                <div>
                  <div className="text-white font-black text-sm uppercase tracking-tight">
                    {event?.organizer?.name}
                  </div>
                  <div className="text-white/40 text-xs">Verified Organizer</div>
                </div>
                <Link
                  to="/marketplace-home"
                  className="ml-auto flex items-center gap-1.5 px-4 py-2 rounded-xl border border-[#1F2937] text-sm text-white/60 hover:bg-white/5 transition-all"
                >
                  View Profile <ExternalLink className="w-3.5 h-3.5" />
                </Link>
              </div>
            </div>
            */}

            {/* FAQ — hidden for now
            <div className="bg-[#111827] rounded-2xl border border-[#1F2937] p-6">
              <h2 className="text-xl font-black uppercase tracking-tight text-white mb-4">
                FAQ
              </h2>
              <div className="space-y-2">
                {faqItems.slice(0, 4).map((faq, i) => (
                  <div
                    key={faq.q}
                    className="rounded-xl border border-[#1F2937] overflow-hidden"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenFaq(openFaq === i ? null : i)}
                      className="w-full flex items-center justify-between p-4 text-sm text-white/80 hover:bg-white/[0.02] transition-colors"
                    >
                      <span className="text-left font-black">{faq.q}</span>
                      {openFaq === i ? (
                        <ChevronUp className="w-4 h-4 shrink-0 text-white/40" />
                      ) : (
                        <ChevronDown className="w-4 h-4 shrink-0 text-white/40" />
                      )}
                    </button>
                    <AnimatePresence>
                      {openFaq === i && (
                        <motion.div
                          initial={{ height: 0 }}
                          animate={{ height: "auto" }}
                          exit={{ height: 0 }}
                          className="overflow-hidden"
                        >
                          <p className="px-4 pb-4 text-sm text-white/50 leading-relaxed">
                            {faq.a}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ))}
              </div>
            </div>
            */}

            {similar.length > 0 && (
              <div>
                <h2 className="text-xl font-black uppercase tracking-tight text-white mb-4">
                  You Might Also Like
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {similar.map((e) => (
                    <button
                      key={e.id}
                      type="button"
                      onClick={() => navigateToSimilar(e.item)}
                      className="group rounded-xl overflow-hidden bg-[#111827] border border-[#1F2937] hover:border-[#374151] transition-all text-left"
                    >
                      <div className="p-3">
                        <div className="text-[10px] text-red-500 font-black uppercase tracking-wider">
                          {e.date}
                        </div>
                        <div className="text-white text-sm font-black uppercase tracking-tight mt-1 truncate group-hover:text-red-500 transition-colors">
                          {e.title}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {isRsvpEvent ? (
              <RsvpCard
                eventId={rsvpEventId}
                ticket={rsvpTicket}
                maxPlusOnes={parseInt(filtertheEvent?.[0]?.maxPlusOnes, 10) || 0}
                remaining={rsvpRemaining}
                user={currentUser}
              />
            ) : (
              <>
            {/* Tickets (left) + seat map (right) */}
            <div className="bg-[#111827] rounded-2xl border border-[#1F2937] overflow-hidden">
              <div className="px-4 sm:px-6 py-4 border-b border-[#1F2937] flex flex-wrap items-center justify-between gap-3">
                <h2 className="text-xl font-black uppercase tracking-tight text-white">
                  Select Tickets
                </h2>
                {soldPercent > 0 && (
                  <span className="text-[10px] text-white/40">{soldPercent}% sold</span>
                )}
              </div>
              <div className="h-1 bg-[#0F172A]">
                <div
                  className={`h-full transition-all ${
                    soldPercent > 90 ? "bg-orange-500" : "bg-red-600"
                  }`}
                  style={{ width: `${soldPercent}%` }}
                />
              </div>

              <div className="relative grid grid-cols-1 lg:grid-cols-[minmax(300px,380px)_1fr] lg:min-h-[720px] lg:h-[min(88vh,900px)] lg:max-h-[900px] items-stretch">
                {sectionLoading && (
                  <div className="absolute inset-0 z-20 bg-[#0B1120] flex items-center justify-center col-span-full">
                    <Loadingcom />
                  </div>
                )}

                {/* Left: fixed header + scrollable tickets */}
                <div className="flex flex-col border-b lg:border-b-0 lg:border-r border-[#1F2937] bg-[#0B1120] order-2 lg:order-1 min-h-0 h-full max-h-[82vh] lg:max-h-full overflow-hidden">
                  <div className="p-4 border-b border-[#1F2937] shrink-0">
                    <div className="rounded-xl bg-gradient-to-br from-[#D4A84B]/10 to-transparent border border-[#D4A84B]/20 p-4">
                      <div className="flex items-center gap-1.5 mb-3">
                        <Zap className="w-3.5 h-3.5 text-[#D4A84B]" />
                        <span
                          className="text-[10px] text-[#D4A84B] uppercase tracking-wider"
                          style={{ fontWeight: 800 }}
                        >
                          InstaPoints Rewards
                        </span>
                      </div>
                      <div className="space-y-2.5">
                        <div className="flex items-center justify-between">
                          <span className="text-[11px] text-white/60">Points earned</span>
                          <span className="text-[12px] text-[#D4A84B]" style={{ fontWeight: 800 }}>
                            +100 pts
                          </span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-[11px] text-white/60">Streak bonus</span>
                          <span className="text-[12px] text-orange-400" style={{ fontWeight: 800 }}>
                            +50 pts
                          </span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-[11px] text-white/60">2X points tonight</span>
                          <span className="text-[12px] text-emerald-400" style={{ fontWeight: 800 }}>
                            Active
                          </span>
                        </div>
                      </div>
                      <div className="mt-3 pt-3 border-t border-[#D4A84B]/10">
                        <div className="flex items-center justify-between mb-1.5">
                          <span className="text-[10px] text-white/30" style={{ fontWeight: 600 }}>
                            Weekend Warrior Challenge
                          </span>
                          <span className="text-[10px] text-[#D4A84B]" style={{ fontWeight: 700 }}>
                            2/3 events
                          </span>
                        </div>
                        <div className="h-1.5 rounded-full bg-[#1F2937] overflow-hidden">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-[#D4A84B] to-[#F5D98A]"
                            style={{ width: "66%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="px-4 py-3 flex items-center justify-between gap-3 border-b border-[#1F2937] shrink-0">
                    <h3 className="text-base sm:text-lg font-bold text-white">Select quantity</h3>
                    <select
                      className="bg-[#0F172A] text-white text-sm rounded-full px-4 py-2 border border-red-600/50 min-w-[140px] focus:outline-none focus:ring-1 focus:ring-red-600"
                      style={{ boxShadow: "0 0 8px rgba(229, 35, 36, 0.25)" }}
                      value={filterQty}
                      onChange={handleFilterQtyChange}
                    >
                      <option value="">Select</option>
                      {splitList.map((item) => (
                        <option key={item} value={item}>
                          {item} {item === 1 ? "Ticket" : "Tickets"}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="px-4 pt-3 pb-1 shrink-0">
                    {parkingRows.length > 0 && !isUserCreatedEvent ? (
                      <div className="flex items-center gap-4">
                        {[
                          { key: false, label: `Tickets (${seatRows.length.toLocaleString()})` },
                          { key: true, label: `Parking (${parkingRows.length.toLocaleString()})` },
                        ].map((tab) => (
                          <button
                            key={String(tab.key)}
                            type="button"
                            onClick={() => {
                              setShowParking(tab.key);
                              setFilterQty("");
                              setSelectedTier(null);
                              setQuantities({});
                            }}
                            className={`text-sm font-black uppercase tracking-wide pb-1 border-b-2 transition-colors ${
                              showParking === tab.key
                                ? "text-red-500 border-red-600"
                                : "text-white/50 border-transparent hover:text-white/80"
                            }`}
                          >
                            {tab.label}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <h3 className="text-sm font-black text-red-500 uppercase tracking-wide border-b border-red-600/40 pb-1 inline-block">
                        All Tickets
                      </h3>
                    )}
                    {!listingParking && mapFilterIds?.size > 0 && (
                      <div className="flex flex-wrap items-center gap-2 mt-2">
                        <span className="text-[10px] text-white/50">
                          Map filter ({displayTicketRows.length})
                        </span>
                        <button
                          type="button"
                          onClick={clearMapFilter}
                          className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-[#1F2937] text-[10px] text-white/70 hover:text-white"
                        >
                          <X className="w-3 h-3" /> Clear
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain px-3 pb-4">
                    {filteredTicketRows.length === 0 ? (
                      <p className="text-center text-white/50 py-8 text-sm px-2">
                        {filterQty
                          ? `No listings available for ${filterQty} ticket${filterQty !== "1" ? "s" : ""}. Try another quantity or section on the map.`
                          : mapFilterIds?.size
                            ? "No tickets in this section. Pick another area on the map or clear the filter."
                            : "No tickets available for this event right now."}
                      </p>
                    ) : (
                      <div className="space-y-2">
                        {filteredTicketRows.map((ticket) => {
                          const qty = quantities[ticket.id] || 0;
                          const isSelected = selectedTier === ticket.id || qty > 0;
                          const rowLabel = ticket.raw?.row || ticket.raw?.tgUserRow;
                          const accentColor =
                            ticket.raw?.sectionStyle?.level?.color ||
                            ticket.raw?.section?.level?.color ||
                            "#CD292E";
                          return (
                            <div
                              key={ticket.id}
                              role="button"
                              tabIndex={0}
                              onClick={() => handleTicketListSelect(ticket)}
                              onKeyDown={(ev) => {
                                if (ev.key === "Enter") handleTicketListSelect(ticket);
                              }}
                              onMouseEnter={() => {
                                setHoveredTicketId(ticket.id);
                                if (!isUserCreatedEvent) highlightTicketOnMap(ticket.raw);
                              }}
                              onMouseLeave={() => {
                                setHoveredTicketId(null);
                                if (!isUserCreatedEvent) clearMapHighlight();
                              }}
                              className={`flex justify-between gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                                isSelected
                                  ? "border-red-600/60 bg-red-600/10"
                                  : "border-[#1F2937] bg-[#111827] hover:border-[#374151]"
                              }`}
                              style={{ borderLeftWidth: 6, borderLeftColor: accentColor }}
                            >
                              <div className="min-w-0 flex-1">
                                <div className="text-white font-bold text-sm">
                                  Section {ticket.name}
                                </div>
                                <div className="text-white/70 text-xs mt-0.5">
                                  Row: {rowLabel || "—"} | {ticket.available}{" "}
                                  {isUserCreatedEvent ? "available" : "tickets"}
                                </div>
                                {ticket.description && (
                                  <div className="text-white/40 text-[11px] mt-1 truncate">
                                    {ticket.description}
                                  </div>
                                )}
                                {qty > 0 && (
                                  <div className="flex items-center gap-2 mt-2">
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleQuantityChange(ticket.id, -1);
                                      }}
                                      className="w-7 h-7 rounded-md bg-[#1F2937] text-white/60 flex items-center justify-center"
                                    >
                                      <Minus className="w-3 h-3" />
                                    </button>
                                    <span className="text-white text-xs font-bold w-6 text-center">
                                      {qty}
                                    </span>
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleQuantityChange(ticket.id, 1);
                                      }}
                                      disabled={qty >= ticket.maxQty || qty >= ticket.available}
                                      className="w-7 h-7 rounded-md bg-[#1F2937] text-white/60 flex items-center justify-center disabled:opacity-40"
                                    >
                                      <Plus className="w-3 h-3" />
                                    </button>
                                  </div>
                                )}
                              </div>
                              <div className="shrink-0 self-center">
                                <div className="bg-gradient-to-br from-red-600 to-red-700 text-white px-3 py-2 rounded-lg text-center min-w-[88px]">
                                  <span className="text-sm font-bold whitespace-nowrap">
                                    ${ticket.price.toFixed(2)}/ea
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {totalQuantity > 0 && (
                    <div className="px-4 py-3 border-t border-[#1F2937] bg-[#0F172A] shrink-0 space-y-1.5 text-sm">
                      <div className="flex justify-between text-white/50">
                        <span>
                          Subtotal ({totalQuantity} ticket{totalQuantity > 1 ? "s" : ""})
                        </span>
                        <span>${subtotal.toFixed(2)}</span>
                      </div>
                      {!isUserCreatedEvent && serviceFee > 0 && (
                        <div className="flex justify-between text-white/50">
                          <span>Service Fee (est.)</span>
                          <span>${serviceFee.toFixed(2)}</span>
                        </div>
                      )}
                      {!isUserCreatedEvent && facilityFee > 0 && (
                        <div className="flex justify-between text-white/50">
                          <span>Facility Fee (est.)</span>
                          <span>${facilityFee.toFixed(2)}</span>
                        </div>
                      )}
                      <div className="flex justify-between text-white font-black pt-1 border-t border-[#1F2937]">
                        <span>Total</span>
                        <span>${totalPrice.toFixed(2)}</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: fixed seat map (does not scroll with ticket list) */}
                <div className="order-1 lg:order-2 min-h-[480px] lg:min-h-0 lg:h-full h-[480px] bg-white flex flex-col overflow-hidden lg:sticky lg:top-24 self-start">
                  <EventSeatMapPanel
                    layout="rightColumn"
                    event={rawEvent}
                    eventId={id}
                    ticketData={ticketData}
                    pageLoading={pageLoading}
                    isUserCreatedEvent={isUserCreatedEvent}
                    onMapReady={handleMapReady}
                    onMapTicketsChange={handleMapTicketsChange}
                    hoveredTicketId={hoveredTicketId}
                    selectedTicketId={selectedTier}
                    onTicketSelect={handleCommunityTicketSelect}
                  />
                </div>
              </div>

              {/* Scan to Buy — hidden for now
              <div className="p-4 sm:px-6 border-t border-[#1F2937]">
                <div className="flex items-center gap-4 p-4 rounded-xl bg-[#0F172A] border border-[#1F2937] max-w-xl">
                  <div className="w-16 h-16 rounded-xl bg-white flex items-center justify-center shrink-0">
                    <QrCode className="w-8 h-8 text-[#0F172A]" />
                  </div>
                  <div>
                    <div className="text-white text-xs font-black uppercase tracking-wider">
                      Scan to Buy
                    </div>
                    <div className="text-white/40 text-[10px] mt-0.5">
                      Point your camera at this QR code to purchase on mobile
                    </div>
                  </div>
                </div>
              </div>
              */}
            </div>
              </>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {[
                  { icon: Shield, text: "100% Guaranteed Authentic" },
                  { icon: Zap, text: "Instant Digital Delivery" },
                  { icon: Users, text: "Secure Peer-to-Peer Transfer" },
                ].map(({ icon: Icon, text }) => (
                  <div
                    key={text}
                  className="flex items-center gap-3 text-sm text-white/50 bg-[#111827] rounded-2xl border border-[#1F2937] p-4"
                  >
                    <Icon className="w-4 h-4 text-red-500 shrink-0" />
                    {text}
                  </div>
                ))}
          </div>
        </div>
      </div>

      {totalQuantity > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-[#111827]/95 backdrop-blur-md border-t border-[#1F2937] p-4 z-40 shadow-[0_-8px_32px_rgba(0,0,0,0.4)]">
          <div className="max-w-[1400px] mx-auto px-4 sm:px-6 flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="text-white font-black text-lg">
                ${totalPrice.toFixed(2)}
              </div>
              <div className="text-white/40 text-xs">
                {totalQuantity} ticket{totalQuantity > 1 ? "s" : ""} selected
                {!isUserCreatedEvent && serviceFee + facilityFee > 0 && (
                  <span className="hidden sm:inline">
                    {" "}
                    · incl. fees
                  </span>
                )}
              </div>
            </div>
            <button
              type="button"
              onClick={handleCheckout}
              className="w-full sm:w-auto px-8 py-3 rounded-xl bg-red-600 text-white font-black uppercase tracking-wider text-sm hover:bg-red-700 shadow-lg shadow-red-600/20"
            >
              {`Checkout — $${totalPrice.toFixed(2)}`}
            </button>
          </div>
        </div>
      )}

      <MarketplaceNewUIFooter />
    </div>
  );
}

export default EventGroupDetailLive;
